export const getFieldIdFromReportFieldDraggableId = (
  reportFieldDraggableId: string,
): string => {
  const splittedData = reportFieldDraggableId.split('-');
  return splittedData[splittedData.length - 1];
};
